<template>
    <div>
        <app-navigation/>
        <app-banner
          backgroundUrl="/press/logos/smallpox.jpeg"
          :headerButtons="headerButtons"
          backgroundSize="cover"
          backgroundPosition="0% 10%"
          title="Professor Raina MacIntyre is interviewed by ABC NEWS about a new strain of Ebola spreading within the DRC"
        />
        <div style="text-align: center; background-color: #e6e8e8; min-height: 50vh;">
            <div class="abc-interview-video-wrap">
              <h2 class="abc-interview-video-title">ABC Interview</h2>
              <video
                class="abc-interview-video"
                controls
                preload="metadata"
              >
                <source src="/media/RainaMacintryre_1805.mp4" type="video/mp4">
                Your browser does not support the video tag.
              </video>
            </div>
        </div>
      <app-footer/>
    </div>
</template>

<script>
// @ is an alias to /src
import AppNavigation from '@/components/AppNavigation.vue'
import AppFooter from '@/components/AppFooter.vue'
import AppBanner from '@/components/AppBanner.vue'

export default {
  name: 'ABCInterview',
  components: {
      AppNavigation,
      AppFooter,
      AppBanner
  },
  data: () => ({
    headerButtons: [],
  })
}
</script>

<style scoped>
.abc-interview-video-wrap {
  margin: 0 auto;
  max-width: 960px;
  padding: 32px 20px 48px;
}

.abc-interview-video-title {
  color: #0d232f;
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 16px;
}

.abc-interview-video {
  border-radius: 8px;
  max-width: 100%;
  width: 100%;
}
</style>